module.exports = __webpack_public_path__ + "static/media/tg.bf9d20b8.svg";